import { render, staticRenderFns } from "./ModuleCrudData.vue?vue&type=template&id=9c5486e0&scoped=true"
import script from "./ModuleCrudData.vue?vue&type=script&lang=js"
export * from "./ModuleCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5486e0",
  null
  
)

export default component.exports